import * as z from 'zod';

import { paginatedResponseSchema } from './paginated-response';

export const stateQuerySchema = z.object({
  id: z.number(),
  name: z.string(),
  abbreviation: z.string(),
  // TODO: PRODUCTION FIX
  // flag_id: z.number(),
  country_id: z.number(),
});

export type StateQuerySchema = z.infer<typeof stateQuerySchema>;

export const stateQueryLinkerSchema = stateQuerySchema.pick({
  id: true,
  name: true,
  abbreviation: true,
});

export type StateQueryLinkerSchema = z.infer<typeof stateQueryLinkerSchema>;

export const stateQueryAllSchema = paginatedResponseSchema(stateQuerySchema);

export type StateQueryAllSchema = z.infer<typeof stateQueryAllSchema>;

export const defaultState: Readonly<StateQuerySchema> = {
  id: -1,
  name: '',
  abbreviation: '',
  // TODO: PRODUCTION FIX
  // flag_id: -1,
  country_id: -1,
} as const;
